// extracted by mini-css-extract-plugin
export default {"title":"CreateProjectModal_title__eK0OI","content":"CreateProjectModal_content__HSn1U","step":"CreateProjectModal_step__twsYK"};